import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RegularButton, Price } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { BasketFlowActions } from 'features/basket';
import { getSet } from 'features/related-products/selectors';
import { Gallery } from './gallery';
import { getSortedProducts } from './utils/get-sorted-products';
import { buySet, setPrice } from './styles';

export const DATA_QA_SET_BLOCK = 'set-block';

export function SetBlock() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const set = useSelector(getSet);

  if (!set) return null;

  // @ts-expect-error TODO исправить после реализации https://tracker.yandex.ru/NAVI-5027
  const eligible = set.eligibility === 'true' || set.eligibility === true;

  const content = getSortedProducts(set.content);

  function addToCart() {
    content.forEach(({ productId, quantity }) => {
      dispatch(BasketFlowActions.UPDATE_ITEM({ productId: `${productId}`, flowQty: quantity }));
    });
  }

  return (
    <div data-qa={DATA_QA_SET_BLOCK}>
      {set.price && (
        <Price
          className={setPrice}
          fraction
          size="xl"
          value={set.price}
          variant="medium"
          color={eligible ? 'text-primary' : 'text-minor'}
        />
      )}
      {eligible && (
        <RegularButton
          onClick={addToCart}
          href="/basket/"
          className={buySet}
          size="l"
          variant="primary"
          wide
        >
          {t('product-info.set.buy')}
        </RegularButton>
      )}
      <Gallery addToCart={addToCart} eligible={eligible} products={content} />
    </div>
  );
}
